const GraphQlStreamMixin = (superClass) => class extends superClass {
  items = null;

  loading = false;

  seeMore = true;
};

export default GraphQlStreamMixin;
